module.exports = __webpack_public_path__ + "img/DK25781309.58b3f2d5.png";